import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    getOpenApiMarkCommunicationAsViewedUrl,
    OpenApiGetCommunicationsMethod,
    type OpenApiGetCommunicationsResponseSuccess,
    OpenApiGetCommunicationsUrl,
    OpenApiMarkCommunicationAsViewedMethod,
    type OpenApiMarkCommunicationAsViewedPathParameters,
    type OpenApiMarkCommunicationAsViewedResponseSuccess,
} from '#shared/api/schema';

const api = createApi({
    name: 'features/Communication/api/communications',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getCommunications: builder.query<OpenApiGetCommunicationsResponseSuccess, void>({
                query: () => {
                    return { method: OpenApiGetCommunicationsMethod, url: OpenApiGetCommunicationsUrl };
                },
            }),
            markCommunicationAsViewed: builder.mutation<
                OpenApiMarkCommunicationAsViewedResponseSuccess,
                OpenApiMarkCommunicationAsViewedPathParameters
            >({
                query: (params) => {
                    return {
                        method: OpenApiMarkCommunicationAsViewedMethod,
                        url: getOpenApiMarkCommunicationAsViewedUrl(params),
                    };
                },
            }),
        };
    },
});

export const useLazyGetCommunications = api.useLazyGetCommunicationsQuery;
export const useMarkCommunicationAsViewed = api.useMarkCommunicationAsViewedMutation;
